/* ═══════════════════════════════════════════════════════════════════════
   QUOTE PAGE CONTROLLER
   Three-stage interface: Quote Build → Quote Reveal → Booking Transition
═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── STATE ──────────────────────────────────────────────────────── */
  var stage    = 1;
  var svcId    = null;
  var dur      = null;
  var lastQ    = null;

  /* Layout proportions (desktop) */
  var F = 0.575;
  var R = 0.390;
  var G = 0.035;

  /* ── DOM REFS ───────────────────────────────────────────────────── */
  var wrap     = document.getElementById('qWrap');
  var pForm    = document.getElementById('qForm');
  var pQuote   = document.getElementById('qQuote');
  var pBook    = document.getElementById('qBook');

  var stepDur  = document.getElementById('stepDur');
  var stepDet  = document.getElementById('stepDet');

  var cards    = document.querySelectorAll('.svc-card');
  var pills    = document.querySelectorAll('.dur-pill');
  var inGuests = document.getElementById('inGuests');
  var inPost   = document.getElementById('inPost');
  var inTime   = document.getElementById('inTime');
  var btnQuote = document.getElementById('btnQuote');
  var hintG    = document.getElementById('hintGuest');

  var errSvc   = document.getElementById('errSvc');
  var errDur   = document.getElementById('errDur');
  var errTime  = document.getElementById('errTime');
  var errGuest = document.getElementById('errGuest');
  var errPost  = document.getElementById('errPost');

  var bkgWrap    = document.getElementById('bkgWrap');
  var bkgSuccess = document.getElementById('bkgSuccess');
  var bkgBadge   = document.getElementById('bkgBadge');
  var bkgForm    = document.getElementById('bkgForm');
  var btnBook    = document.getElementById('btnBook');

  /* ── MOBILE DETECTION ───────────────────────────────────────────── */
  function mob() { return window.innerWidth < 768; }

  /* ── PANEL POSITIONING ──────────────────────────────────────────── */
  function pin(el, left, w, op) {
    el.style.left         = left + 'px';
    el.style.width        = w + 'px';
    el.style.opacity      = op;
    el.style.pointerEvents = op > 0 ? 'auto' : 'none';
    if (op === 0) el.setAttribute('aria-hidden', 'true');
    else          el.removeAttribute('aria-hidden');
  }

  function setH(h) {
    if (!mob()) wrap.style.height = Math.ceil(h) + 'px';
  }

  function updateMobHeight() {
    if (!mob()) return;
    var active = stage === 1 ? pForm : stage === 2 ? pQuote : pBook;
    var needed  = active.scrollHeight + 80;
    var current = parseFloat(wrap.style.minHeight) || 0;
    wrap.style.minHeight = Math.max(needed, current, window.innerHeight) + 'px';
  }

  /* ── LAYOUT ─────────────────────────────────────────────────────── */
  function layout(animated) {
    if (mob()) { layoutMob(animated); return; }

    var W = wrap.offsetWidth;

    if (!animated) {
      pForm.style.transition  = 'none';
      pQuote.style.transition = 'none';
      pBook.style.transition  = 'none';
    }

    if (stage === 1) {
      var fw = Math.min(680, W);
      pin(pForm,  Math.max(0, (W - fw) / 2), fw,   1);
      pin(pQuote, W + 100,                   W * R, 0);
      pin(pBook,  W + 100,                   W * R, 0);
      setH(pForm.scrollHeight + 96);
    } else if (stage === 2) {
      pin(pForm,  0,           W * F, 1);
      pin(pQuote, W * (F + G), W * R, 1);
      pin(pBook,  W + 100,     W * R, 0);
      raf(function () { setH(Math.max(pForm.scrollHeight, pQuote.scrollHeight) + 96); });
    } else {
      pin(pForm,  -(W * 0.70),  W * F, 0);
      pin(pQuote, 0,            W * R, 1);
      pin(pBook,  W * (R + G),  W * F, 1);
      raf(function () { setH(Math.max(pQuote.scrollHeight, pBook.scrollHeight) + 96); });
    }

    if (!animated) {
      raf(function () { raf(function () {
        pForm.style.transition  = '';
        pQuote.style.transition = '';
        pBook.style.transition  = '';
      }); });
    }
  }

  function layoutMob(animated) {
    var W = wrap.offsetWidth;
    [pForm, pQuote, pBook].forEach(function (p) {
      p.style.left  = '0';
      p.style.width = W + 'px';
      if (!animated) p.style.transition = 'none';
    });

    if (stage === 1) {
      mobSlide(pForm,  'translateX(0)',     1, true);
      mobSlide(pQuote, 'translateX(110%)',  0, false);
      mobSlide(pBook,  'translateX(110%)',  0, false);
    } else if (stage === 2) {
      mobSlide(pForm,  'translateX(-110%)', 0, false);
      mobSlide(pQuote, 'translateX(0)',     1, true);
      mobSlide(pBook,  'translateX(110%)',  0, false);
    } else {
      mobSlide(pForm,  'translateX(-110%)', 0, false);
      mobSlide(pQuote, 'translateX(-110%)', 0, false);
      mobSlide(pBook,  'translateX(0)',     1, true);
    }

    raf(function () { updateMobHeight(); });

    if (!animated) {
      raf(function () { raf(function () {
        [pForm, pQuote, pBook].forEach(function (p) { p.style.transition = ''; });
      }); });
    }
  }

  function mobSlide(el, transform, opacity, active) {
    el.style.transform     = transform;
    el.style.opacity       = opacity;
    el.style.pointerEvents = active ? 'auto' : 'none';
    if (active) el.removeAttribute('aria-hidden');
    else        el.setAttribute('aria-hidden', 'true');
  }

  function goTo(n) {
    stage = n;
    layout(true);
    if (mob()) {
      setTimeout(function () {
        var top = wrap.getBoundingClientRect().top + window.pageYOffset - 8;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }, 80);
    }
  }

  /* ── STEP REVEAL ────────────────────────────────────────────────── */
  function showStep(el, num) {
    var nEl = el.querySelector('.step-num');
    if (nEl && num !== undefined) nEl.textContent = num;
    if (!el.hidden) return;

    el.hidden = false;
    el.classList.remove('step-enter');
    void el.offsetHeight;
    el.classList.add('step-enter');

    raf(function () {
      if (stage === 1) setH(pForm.scrollHeight + 96);
      updateMobHeight();
      /* On mobile, scroll just enough to reveal the new step near the
         bottom of the viewport — only fires if it's actually out of view */
      if (mob()) {
        var rect         = el.getBoundingClientRect();
        var neededScroll = rect.bottom - window.innerHeight + 32;
        if (neededScroll > 0) {
          smoothScrollTo(window.pageYOffset + neededScroll, 480);
        }
      }
    });
    el.addEventListener('animationend', function () {
      el.classList.remove('step-enter');
      if (stage === 1) setH(pForm.scrollHeight + 96);
      updateMobHeight();
    }, { once: true });
  }

  /* Controlled scroll with easeOutCubic — starts at full speed immediately
     then decelerates smoothly, giving a more natural feel than the browser
     default which accelerates before decelerating */
  function smoothScrollTo(target, duration) {
    var start     = window.pageYOffset;
    var distance  = target - start;
    var startTime = null;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      window.scrollTo(0, start + distance * easeOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function hideStep(el, callback) {
    if (el.hidden) {
      if (callback) callback();
      return;
    }
    el.classList.add('step-leaving');
    el.addEventListener('animationend', function () {
      el.classList.remove('step-leaving');
      el.hidden = true;
      if (stage === 1) setH(pForm.scrollHeight + 96);
      updateMobHeight();
      if (callback) callback();
    }, { once: true });
  }

  function hideStepSmooth(stepToHide, stepToAnchor, onComplete) {
    if (stepToHide.hidden) {
      if (onComplete) onComplete();
      return;
    }

    var collapseHeight = stepToHide.offsetHeight;
    var marginBottom   = parseFloat(window.getComputedStyle(stepToHide).marginBottom) || 0;
    var totalShift     = collapseHeight + marginBottom;

    stepToHide.style.transition    = 'opacity 0.22s ease';
    stepToHide.style.pointerEvents = 'none';
    void stepToHide.offsetHeight;
    stepToHide.style.opacity = '0';

    stepToHide.addEventListener('transitionend', function () {
      stepToHide.style.transition    = '';
      stepToHide.style.opacity       = '';
      stepToHide.style.pointerEvents = '';

      if (stepToAnchor && !stepToAnchor.hidden) {
        stepToAnchor.style.marginTop = totalShift + 'px';
      }

      stepToHide.hidden = true;

      if (stepToAnchor && !stepToAnchor.hidden) {
        void stepToAnchor.offsetHeight;
        stepToAnchor.style.transition = 'margin-top 0.45s cubic-bezier(0.25, 1, 0.5, 1)';

        raf(function () {
          stepToAnchor.style.marginTop = '0';
          stepToAnchor.addEventListener('transitionend', function () {
            stepToAnchor.style.transition = '';
            stepToAnchor.style.marginTop  = '';
            if (stage === 1) setH(pForm.scrollHeight + 96);
            updateMobHeight();
            if (onComplete) onComplete();
          }, { once: true });
        });
      } else {
        if (stage === 1) setH(pForm.scrollHeight + 96);
        updateMobHeight();
        if (onComplete) onComplete();
      }
    }, { once: true });
  }

  /* ── SERVICE CARD SELECTION ─────────────────────────────────────── */
  cards.forEach(function (card) {
    function handle() {
      cards.forEach(function (c) {
        c.classList.remove('is-sel');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-sel');
      card.setAttribute('aria-pressed', 'true');

      svcId = card.dataset.svc;
      dur   = null;
      pills.forEach(function (p) { p.classList.remove('is-active'); });
      clr(errSvc);

      var svc = PeachyPricingEngine.getService(svcId);
      hintG.textContent = svc.minGuests > 1 ? 'Minimum ' + svc.minGuests + ' guests' : '';

      if (svc.fixedDuration) {
        dur = svc.fixedDuration;
        if (!stepDet.hidden) {
          hideStepSmooth(stepDur, stepDet, function () {
            var n = stepDet.querySelector('.step-num');
            if (n) n.textContent = '2';
          });
        } else {
          hideStep(stepDur, function () { showStep(stepDet, 2); });
        }
      } else {
        showStep(stepDur, 2);
        hideStep(stepDet);
      }
    }
    card.addEventListener('click', handle);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handle(); }
    });
  });

  /* ── DURATION PILL SELECTION ────────────────────────────────────── */
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      dur = parseInt(pill.dataset.dur, 10);
      clr(errDur);
      showStep(stepDet, 3);
    });
  });

  inGuests.addEventListener('input', function () { clr(errGuest); });
  inPost.addEventListener('input',   function () { clr(errPost);  });
  inTime.addEventListener('input',   function () { clr(errTime);  });

  /* ── GET QUOTE ──────────────────────────────────────────────────── */
  btnQuote.addEventListener('click', async function () {
    if (!validateQ()) return;
    setQLd(true);
    clrAll();
    try {
      var result = await PeachyPricingEngine.generateQuote({
        serviceId: svcId,
        duration:  dur,
        guests:    parseInt(inGuests.value, 10),
        postcode:  inPost.value.trim(),
        startTime: inTime.value || null,
      });
      lastQ = result;
      lastQ.startTime = inTime.value || null;
      renderQuote(lastQ);
      goTo(2);
    } catch (err) {
      var m = err.message || 'Something went wrong — please try again.';
      if (m.toLowerCase().includes('postcode'))  set$(errPost,  m);
      else if (m.toLowerCase().includes('guest')) set$(errGuest, m);
      else                                        set$(errSvc,   m);
    } finally {
      setQLd(false);
    }
  });

  /* ── RENDER QUOTE PANEL ─────────────────────────────────────────── */
  function renderQuote(q) {
    var inner = document.getElementById('qQuoteInner');
    inner.innerHTML = q.requiresCustomQuote ? buildCustom(q) : buildReceipt(q);

    if (!q.requiresCustomQuote) {
      var bookNowBtn = document.getElementById('btnBookNow');
      bookNowBtn.addEventListener('click', function () {
        populateBooking(q);
        goTo(3);
        bookNowBtn.classList.add('r-btn--used');
        bookNowBtn.disabled = true;
      });
    }
  }

  function buildReceipt(q) {
    var b = q.breakdown, s = q.service, t = q.travelBand;
    var svcCfg = PeachyPricingEngine.getService(s.id);
    var lbl = svcCfg.pricing.type === 'per-person'
      ? s.name + ' <span class="dim">£' + svcCfg.pricing.pricePerPerson + ' × ' + q.guests + '</span>'
      : s.name + ' <span class="dim">' + q.duration + 'hr' + (q.duration > 1 ? 's' : '') + '</span>';
    var tVal = b.travelSurcharge === 0
      ? '<span class="r-val dimmer">Included</span>'
      : '<span class="r-val">£' + b.travelSurcharge + '</span>';
    var mods = b.modifiers.map(function (m) {
      return '<div class="r-row"><span>' + m.label + '</span><span class="r-val">+£' + m.amount + '</span></div>';
    }).join('');

    /* Format start time as human-readable e.g. "9:00 PM" */
    var timeDisplay = '';
    if (q.startTime) {
      var parts = q.startTime.split(':');
      var h = parseInt(parts[0], 10), mn = parts[1];
      var ampm = h >= 12 ? 'PM' : 'AM';
      var h12  = h % 12 || 12;
      timeDisplay = '&nbsp;·&nbsp;' + h12 + ':' + mn + ' ' + ampm;
    }

    return [
      '<div class="r-card">',
      '<p class="r-eye">Your Estimate</p>',
      '<p class="r-name">' + s.name + '</p>',
      '<p class="r-meta">' + q.duration + ' hr' + (q.duration > 1 ? 's' : '') + '&nbsp;·&nbsp;' + q.guests + ' guest' + (q.guests !== 1 ? 's' : '') + timeDisplay + '</p>',
      '<p class="r-zone">~' + q.miles + ' miles from ' + PeachyPricingEngine.config.base.label + '</p>',
      '<div class="r-div"></div>',
      '<div class="r-row"><span>' + lbl + '</span><span class="r-val">£' + b.basePrice + '</span></div>',
      mods,
      '<div class="r-row"><span>Travel</span>' + tVal + '</div>',
      '<div class="r-div"></div>',
      '<div class="r-total"><span class="r-total-lbl">Est. Total</span><span class="r-total-val">£' + b.estimatedTotal + '</span></div>',
      '<p class="r-disc">Starting from — final pricing confirmed on booking.</p>',
      '<button class="r-btn" id="btnBookNow" type="button">Book Now</button>',
      '</div>',
    ].join('');
  }

  function buildCustom(q) {
    return [
      '<div class="r-card r-card--custom">',
      '<p class="r-eye">Custom Quote Required</p>',
      "<p class=\"r-name\">Let's talk!</p>",
      '<p class="r-meta">~' + q.miles + ' mi from Bristol</p>',
      '<p class="r-custom-msg">' + q.reason + '</p>',
      '<a href="/contact_us.html" class="r-btn" style="display:block;text-align:center;text-decoration:none">Contact Us</a>',
      '</div>',
    ].join('');
  }

  /* ── POPULATE BOOKING PANEL ─────────────────────────────────────── */
  var PKG = {
    'single-butler-1':  '1 Peachy Butler – 1 Hour',
    'single-butler-2':  '1 Peachy Butler – 2 Hours',
    'single-butler-3':  '1 Peachy Butler – 3 Hours',
    'double-butler-1':  '2 Peachy Butlers – 1 Hour',
    'double-butler-2':  '2 Peachy Butlers – 2 Hours',
    'double-butler-3':  '2 Peachy Butlers – 3 Hours',
    'cocktail-class-2': "Peachy's Cocktail Class",
  };

  function populateBooking(q) {
    var label = PKG[q.service.id + '-' + q.duration] || q.service.name;
    bkgBadge.textContent = label;
    setVal('bkgPkgFld',    label);
    setVal('bkgPriceFld',  '£' + q.breakdown.estimatedTotal + ' (est.)');
    setVal('bkgBaseFld',   '£' + q.breakdown.basePrice);
    setVal('bkgBandFld',   q.travelBand.label + ' — ' + q.travelBand.description);
    setVal('bkgTravelFld', q.breakdown.travelSurcharge === 0 ? 'Included' : '£' + q.breakdown.travelSurcharge);
    setVal('bkgSvcFld',    q.service.name);
    setVal('bkgButlerFld', q.service.butlerCount + ' butler' + (q.service.butlerCount > 1 ? 's' : ''));
    setVal('bkgHoursFld',  q.duration + ' hour' + (q.duration > 1 ? 's' : ''));
    setVal('bkgGuestFld',  q.guests + ' guest' + (q.guests > 1 ? 's' : ''));
    setVal('bkgPostFld',   inPost.value.trim().toUpperCase());
    setVal('bkgMilesFld',  q.miles + ' miles');
    /* Start time + late-night surcharge */
    setVal('bkgTimeFld',   q.startTime || 'Not specified');
    var timeMod = q.breakdown.modifiers.find(function (m) { return m.id === 'unsociable-hours'; });
    setVal('bkgTimeSurchargeFld', timeMod ? '£' + timeMod.amount : 'None');
  }

  function setVal(id, val) {
    var el = document.getElementById(id);
    if (el) el.value = val;
  }

  /* ── BOOKING FORM SUBMISSION ─────────────────────────────────────── */
  bkgForm.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (!validateB()) return;
    btnBook.disabled = true;
    btnBook.innerHTML = '<span class="spinner"></span>&nbsp;Submitting…';

    try {
      var res = await fetch('https://formspree.io/f/mgobvkql', {
        method: 'POST',
        body: new FormData(bkgForm),
        headers: { 'Accept': 'application/json' },
      });
      if (res.ok) {
        window.location.href = '/thank_you.html';
      } else {
        btnBook.disabled = false;
        btnBook.textContent = 'Confirm Booking';
        alert('Something went wrong — please try again or contact us directly.');
      }
    } catch (_) {
      btnBook.disabled = false;
      btnBook.textContent = 'Confirm Booking';
      alert('Unable to submit. Please contact info@peachybutlers.com directly.');
    }
  });

  /* ── VALIDATION ─────────────────────────────────────────────────── */
  function validateQ() {
    clrAll(); var ok = true;
    if (!svcId) { set$(errSvc, 'Please select a service.'); ok = false; }
    var svc = svcId ? PeachyPricingEngine.getService(svcId) : null;
    if (svc && !svc.fixedDuration && !dur) { set$(errDur, 'Please select a duration.'); ok = false; }
    if (!inTime.value) { set$(errTime, 'Please enter your event start time.'); ok = false; }
    var g = parseInt(inGuests.value, 10);
    if (!inGuests.value || isNaN(g) || g < 1) {
      set$(errGuest, 'Please enter a valid number of guests.'); ok = false;
    } else if (svc && svc.minGuests && g < svc.minGuests) {
      set$(errGuest, svc.name + ' requires at least ' + svc.minGuests + ' guests.'); ok = false;
    }
    if (!inPost.value.trim()) { set$(errPost, 'Please enter your event postcode.'); ok = false; }
    return ok;
  }

  function validateB() {
    var ok = true;
    var chk = [
      { id: 'bName',  err: 'bErrName',  msg: 'Please enter your name.' },
      { id: 'bEmail', err: 'bErrEmail', msg: 'Please enter a valid email address.',
        test: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); } },
      { id: 'bPhone', err: 'bErrPhone', msg: 'Please enter a phone number.' },
      { id: 'bDate',  err: 'bErrDate',  msg: 'Please select your event date.' },
      { id: 'bDets',  err: 'bErrDets',  msg: 'Please add your event location.' },
    ];
    chk.forEach(function (f) {
      var el = document.getElementById(f.id);
      var er = document.getElementById(f.err);
      var v  = el.value.trim();
      if (!v || (f.test && !f.test(v))) { set$(er, f.msg); ok = false; }
      else clr(er);
    });
    var consent = document.getElementById('bConsent');
    var conErr  = document.getElementById('bErrConsent');
    if (!consent.checked) { set$(conErr, 'Please give your consent to continue.'); ok = false; }
    else clr(conErr);
    return ok;
  }

  /* ── UTILITIES ──────────────────────────────────────────────────── */
  function set$(el, m) { if (el) el.textContent = m; }
  function clr(el)     { if (el) el.textContent = ''; }
  function clrAll()    { [errSvc, errDur, errTime, errGuest, errPost].forEach(clr); }
  function raf(fn)     { requestAnimationFrame(fn); }

  function setQLd(on) {
    btnQuote.disabled = on;
  }

  /* ── RESIZE ─────────────────────────────────────────────────────── */
  var resizeTmr;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTmr);
    resizeTmr = setTimeout(function () { layout(false); }, 80);
  });

  /* ── INIT ───────────────────────────────────────────────────────── */
  function init() {
    layout(false);
    readUrlParams();
  }

  function readUrlParams() {
    var params   = new URLSearchParams(window.location.search);
    var svcParam = params.get('service');
    var durParam = parseInt(params.get('duration'), 10);

    if (!svcParam) return;

    raf(function () { raf(function () { raf(function () {
      var card = document.querySelector('[data-svc="' + svcParam + '"]');
      if (!card) return;
      card.click();

      if (!isNaN(durParam)) {
        raf(function () {
          var pill = document.querySelector('[data-dur="' + durParam + '"]');
          if (pill) pill.click();
        });
      }
    }); }); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
